import React, { useEffect, useState } from 'react'
import GenerateForm from '../Form/GenerateForm'
import DynamicForm, { IDynamicForm } from '../Form/DynamicForm'
import { useDispatch } from 'react-redux'
import { createOrUpdateElementData, createOrUpdateForm } from '../Form/formsSlice'
import { ISearchParam } from '../../features/BaseApp'
import { Checkbox, FormControlLabel } from '@mui/material'

interface IProps {
    shown: boolean,
    form: IDynamicForm,
    updateSearchParams: (params: ISearchParam[]) => void,
    searchParams: ISearchParam[],
    addAdditionalFilters?: (searchParams: ISearchParam[], updateSearchParams: (params: ISearchParam[]) => void) => JSX.Element,
    enableLoadItemsOnSearchParamsChange: boolean,
    setEnableLoadItemsOnSearchParamsChange: (val: boolean) => void,
}

export default function GridDataFilter(props: IProps) {

    const dispatch = useDispatch()

    const { 
        shown, 
        form, 
        updateSearchParams, 
        searchParams, 
        addAdditionalFilters,
        enableLoadItemsOnSearchParamsChange,
        setEnableLoadItemsOnSearchParamsChange, 
    } = props

    const filterBaseContainerClassName: string = "form-container-of-filter-bar-of-grid-data"
    const [filterContainerClassName, setFilterContainerClassName] = useState<string>(filterBaseContainerClassName)

    const elementsData = DynamicForm.useReturnAllFormsData()
    const elemPrefix: string = "filter" + "_"

    const [updatedFields, setUpdatedFields] = useState<string[]>([])

    /**
     * New updated field
     */
    const addUpdatedField = (id: string) => {
        setUpdatedFields(prev => 
            prev.includes(id) ? prev : [...prev, id]
        )
    }   

    /**
     * Remove updated field
     */
    const removeUpdatedField = (id: string) => {
        setUpdatedFields(prev => prev.filter(field => field !== id))
    }

    /**
     * Handle filter form on change
     */
    const handleFilterFormOnChange = (id: string, value: any) => {

        if (typeof value === "object"){
            value = value.value
        }

        dispatch(createOrUpdateElementData({
            name: id,
            value: value
        }))

        addUpdatedField(id)

        // let params = [
        //     ...searchParams
        // ]

        // const convertedName = id.replace(elemPrefix, "")

        // if (!params.some(item => item.name === convertedName)){
        //     params.push({ name: convertedName, value: value })
        // }else{
            
        //     const index = params.findIndex(item => item.name === convertedName)

        //     if (index !== -1){
        //         params[index] = { name: convertedName, value: value }
        //     }

        // }

        // updateSearchParams(params)
        
    }

    /**
     * Show container
     */
    useEffect(() => {
        setFilterContainerClassName(shown ? filterBaseContainerClassName + " active" : filterBaseContainerClassName)
    }, [shown])

    /**
     * Register filter form
     */
    useEffect(() => {
        if (form){
            dispatch(createOrUpdateForm(form))

            form.elements.map((elem) => dispatch(createOrUpdateElementData({ name: elemPrefix + elem.id, value: "" })))

        }
    }, [form])

    /**
     * Update searchParams
     */
    useEffect(() => {

        let newSearchParams = [...searchParams]

        if (updatedFields.length > 0){

            updatedFields.map((field) => {

                const value = DynamicForm.returnSingleFormElementData(field, elementsData).value

                if (newSearchParams.find((param) => param.name === field)){
                    const findIndex = newSearchParams.findIndex((param) => param.name === field)

                    if (newSearchParams[findIndex]){
                        newSearchParams[findIndex] = {
                            ...newSearchParams[findIndex],
                            value: value
                        }
                    }
                }else{
                    newSearchParams = [
                        ...newSearchParams,
                        {
                            name: field,
                            value: value
                        }
                    ]
                }

                removeUpdatedField(field)

            })

            updateSearchParams(newSearchParams)
        }

    }, [updatedFields])

    return(
        <div className={filterContainerClassName}>
            <div className="content-of-form-container-of-filter-bar-of-grid-data">
                <GenerateForm name={form.name} customHandleOnChange={handleFilterFormOnChange} />

                {addAdditionalFilters && (
                    <div className="additional-data-of-form-container-of-filter-bar-of-grid-data">
                        {addAdditionalFilters(searchParams, updateSearchParams)}
                    </div>
                )}

                <div className="filter-checkbox-of-form-container-of-filter-bar-of-grid-data">
                    <FormControlLabel control={<Checkbox checked={enableLoadItemsOnSearchParamsChange} onChange={(e) => setEnableLoadItemsOnSearchParamsChange(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Enable refresh on search parameters change" />
                </div>
                
            </div>
        </div>
    )
}